// QuePasa Plugin: Inbox Actions Extension
// Adds actions for merging duplicate conversations

/* global axios */

export const inboxesActions = {
  // Get statistics about duplicate conversations
  async getDuplicateConversations(contextOrPayload, maybePayload) {
    try {
      // Handle both calling conventions:
      // 1. Vuex standard: (context, payload)
      // 2. Our plugin system: (payload) where context becomes the payload
      let inboxId, accountId;
      
      if (contextOrPayload && typeof contextOrPayload === 'object') {
        if (contextOrPayload.inboxId !== undefined) {
          // Direct payload (context IS the payload)
          inboxId = contextOrPayload.inboxId;
          // Extract accountId from current URL: /app/accounts/:accountId/...
          const match = window.location.pathname.match(/\/accounts\/(\d+)/);
          accountId = match ? match[1] : null;
        } else if (maybePayload?.inboxId !== undefined) {
          // Standard Vuex convention
          inboxId = maybePayload.inboxId;
          accountId = contextOrPayload.state?.auth?.accountId || contextOrPayload.rootState?.auth?.accountId;
        }
      }
      
      if (!inboxId || !accountId) {
        console.error('[API-CONVERSATIONS-MERGE] Missing inboxId or accountId', { 
          inboxId, 
          accountId, 
          contextOrPayload, 
          maybePayload,
          pathname: window.location.pathname
        });
        throw new Error('Missing required parameters');
      }

      const response = await axios.get(
        `/api/v1/accounts/${accountId}/inboxes/${inboxId}/merge_conversations/stats`
      );
      return response;
    } catch (error) {
      console.error('[API-CONVERSATIONS-MERGE] Error fetching stats:', error);
      throw error;
    }
  },

  // Merge all duplicate conversations
  async mergeDuplicateConversations(contextOrPayload, maybePayload) {
    try {
      let inboxId, accountId;
      
      if (contextOrPayload && typeof contextOrPayload === 'object') {
        if (contextOrPayload.inboxId !== undefined) {
          // Direct payload
          inboxId = contextOrPayload.inboxId;
          const match = window.location.pathname.match(/\/accounts\/(\d+)/);
          accountId = match ? match[1] : null;
        } else if (maybePayload?.inboxId !== undefined) {
          // Standard Vuex convention
          inboxId = maybePayload.inboxId;
          accountId = contextOrPayload.state?.auth?.accountId || contextOrPayload.rootState?.auth?.accountId;
        }
      }
      
      if (!inboxId || !accountId) {
        console.error('[API-CONVERSATIONS-MERGE] Missing inboxId or accountId');
        throw new Error('Missing required parameters');
      }

      const response = await axios.post(
        `/api/v1/accounts/${accountId}/inboxes/${inboxId}/merge_conversations/merge`
      );
      return response;
    } catch (error) {
      console.error('[API-CONVERSATIONS-MERGE] Error merging conversations:', error);
      throw error;
    }
  },

  // Get statistics about duplicate CONTACTS (BR 8/9-digit variant)
  async getDuplicateContacts(contextOrPayload, maybePayload) {
    const { inboxId, accountId } = resolveMergeIds(contextOrPayload, maybePayload);
    const response = await axios.get(
      `/api/v1/accounts/${accountId}/inboxes/${inboxId}/merge_conversations/contact_stats`
    );
    return response;
  },

  // Merge all duplicate contacts (background job)
  async mergeDuplicateContacts(contextOrPayload, maybePayload) {
    const { inboxId, accountId } = resolveMergeIds(contextOrPayload, maybePayload);
    const response = await axios.post(
      `/api/v1/accounts/${accountId}/inboxes/${inboxId}/merge_conversations/merge_contacts`
    );
    return response;
  },

  // Status of the duplicate-contacts merge job
  async getDuplicateContactsStatus(contextOrPayload, maybePayload) {
    const { inboxId, accountId } = resolveMergeIds(contextOrPayload, maybePayload);
    const response = await axios.get(
      `/api/v1/accounts/${accountId}/inboxes/${inboxId}/merge_conversations/contacts_status`
    );
    return response;
  },
};

// Shared id resolution for both calling conventions (see getDuplicateConversations)
function resolveMergeIds(contextOrPayload, maybePayload) {
  let inboxId;
  let accountId;
  if (contextOrPayload && typeof contextOrPayload === 'object') {
    if (contextOrPayload.inboxId !== undefined) {
      inboxId = contextOrPayload.inboxId;
      const match = window.location.pathname.match(/\/accounts\/(\d+)/);
      accountId = match ? match[1] : null;
    } else if (maybePayload?.inboxId !== undefined) {
      inboxId = maybePayload.inboxId;
      accountId =
        contextOrPayload.state?.auth?.accountId ||
        contextOrPayload.rootState?.auth?.accountId;
    }
  }
  if (!inboxId || !accountId) {
    console.error('[API-CONVERSATIONS-MERGE] Missing inboxId or accountId');
    throw new Error('Missing required parameters');
  }
  return { inboxId, accountId };
}
